import { mapState, mapActions } from 'vuex'
import services from '@/services'

export default {
  name: 'ModalImportFile',
  data () {
    return {
      isLoading: false,
      file: null,
      labelButton: 'Importar arquivo',
      importing: false,
      provider: null,
      accept_partial_import: false,
      error: null
    }
  },

  computed: {
    ...mapState({
      isVisibleModal: ({ modal }) => modal.isVisibleModal,
      loading: ({ importFile }) => importFile.loading,
      listImportFiles: ({ importFile }) => importFile.listImportFiles,
      metaDataFiles: ({ importFile }) => importFile.metaDataFiles,
      campaignId: ({ campaign }) => campaign.campaign.id
    })
  },

  methods: {
    ...mapActions('importFile', ['getAllFiles']),

    toggle () {
      this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL', false)
      this.provider = null
      this.accept_partial_import = false
      this.file = null
      this.$refs.file.value = null
      this.labelButton = 'Importar arquivo'
    },

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      this.labelButton = this.file.name
      this.importing = true
    },

    uploadFileExemple () {
      this.isLoading = true
      const { malaDireta } = services
      let formData = new FormData()

      formData.append('provider', this.provider)
      formData.append('accept_partial_import', this.accept_partial_import)
      formData.append('file', this.file)

      malaDireta.importFile.uploadFileExemple ( formData, this.campaignId )
      .then(response => {
        this.getAllFiles({
          page: this.metaDataFiles.currentPage,
          limit: 50,
          campaignId: this.campaignId,
          orderBy: 'import_files.created_at',
          order: 'desc'

        })
        this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
        this.$store.commit('statusBar/SET_TYPE_BAR', 'warning')
        this.$store.commit('statusBar/SET_TITLE_BAR', 'Importando arquivos - Será enviada para o o seu e-mail assim que concluída - Isso pode demorar alguns minutos.')
        this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL', false)
        this.provider = ''
        this.accept_partial_import = false
        this.file = null
        this.$refs.file.value = null
        this.labelButton = 'Importar arquivo'
        this.isLoading = false

      })
      .catch((e) => {
        this.errors(e)
        this.$store.commit('statusBar/SET_TYPE_BAR', 'error')
        this.$store.commit('statusBar/SET_TITLE_BAR', 'Falha ao importar arquivo.')
        setTimeout( () => {
          this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
        }, 9000)
        this.provider = ''
        this.accept_partial_import = false
        this.file = ''
        this.labelButton = 'Importar arquivo'
        this.isLoading = false
        this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL', false)
      })
    },

    getFileExemple () {
      const { malaDireta } = services

      malaDireta.fileExemple.getFileExemple()
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'arquivo_de_exemplo.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
    }
  }
};
